<template>
  <v-dialog scrollable persistent v-model="config.status.active" max-width="600">
    <!-- <AuthorCard v-if="this.store.type === 'author'"
      ref="author"
      :fixed="isFixed"
      :date="$props.date || ''"
      @change="change('client')"
      @close="close"
      @done="done"
    /> -->
    <ConsultCard v-if="getType === 'consult'"
      ref="consult"
      :cid="getClientId"
      :fixed="isFixed"
      :date="$props.date || ''"
      :type="getType"
      @change="change"
      @close="close"
      @done="done"
    />
    <EventCard v-if="getType === 'event'"
      ref="event"
      :cid="getClientId"
      :fixed="isFixed"
      :date="$props.date || ''"
      :type="getType"
      @change="change"
      @close="close"
      @done="done"
    />
  </v-dialog>
</template>

<script>
import ConsultCard from './consult'
import EventCard from './event'
export default {
  name: 'sasmango-calendar-editor',
  props: [
    'type',
    'cid',
    'fixed',
    'date'
  ],
  components: {
    ConsultCard,
    EventCard
  },
  data () {
    return {
      config: {
        status: {
          active: false
        }
      },
      store: {
        type: 'event'
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function (eventType) {
    },
    open: function (req) {
      const { type, event } = req || { type: 'insert', event: {} }
      const cid = event.cid || ''
      const eventType = event.type || this.$props.type || 'event'
      this.$set(this.store, 'type', eventType)
      this.$set(this.config.status, 'active', true)
      setTimeout(() => {
        if (type == 'insert') {
          this.$refs[eventType].openForInsert(event.props || event)
        } else if (type === 'update') {
          this.$refs[eventType].openForUpdate(event.props || event)
        }
      }, 500)
      this.$nextTick(() => {
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    change: function (type) {
      if (type) {
        this.$set(this.store, 'type', type)
        this.$nextTick(() => {
          this.$refs[type].openForInsert()
        })
      }
    },
    done: function (req) {
      this.$emit('done', req)
    }
  },
  computed: {
    isFixed () {
      return this.$props.fixed
    },
    getClientId () {
      return this.$props.cid || ''
    },
    getType () {
      return this.$props.type || this.store.type
    }
  }
}
</script>